export const TELEMETRY_DB_BASE_NAME = "my-pwa-db";
export const TELEMETRY_DB_NAME = `${TELEMETRY_DB_BASE_NAME}-telemetry`;
export const TELEMETRY_DB_VERSION = 1;
export const TELEMETRY_STORE = "events";
export const TELEMETRY_DEFAULT_APP = "EventsApp";
export const TELEMETRY_EVENT_TYPES = Object.freeze({
  API_ERROR: "API_ERROR",
  API_REQUEST: "API_REQUEST",
  BUSINESS_EVENT: "BUSINESS_EVENT",
  IDB_ERROR: "IDB_ERROR",
  PERFORMANCE_METRIC: "PERFORMANCE_METRIC",
  RUNTIME_ERROR: "RUNTIME_ERROR",
  SW_ERROR: "SW_ERROR",
  SW_SYNC_EVENT: "SW_SYNC_EVENT",
  SYNC_FAILURE: "SYNC_FAILURE",
  SYSTEM_HEALTH: "SYSTEM_HEALTH",
});
